import { apiClient, bearer, unwrap } from './client';
import type { RuleSetListOut } from './types';

export function listRuleSets(idToken: string): Promise<RuleSetListOut> {
  return apiClient
    .GET('/api/rule-sets', { headers: bearer(idToken) })
    .then(unwrap<RuleSetListOut>);
}
